export default __webpack_public_path__ + "static/media/best.535b1470.png";